module.exports = __webpack_public_path__ + "img/fleet-vin.cbfce7e1.svg";